import React, { useEffect, useState } from 'react'
import firebase from '../../config/fbConfig'
import ExportButton from '../instructions/ExportButton'
import PaidImagePreview from '../layout/PaidImagePreview'
import PaidTemplatePreview from '../layout/PaidTemplatePreview'

async function GetPaymentStatus(clientId) {
  return await firebase.firestore().collection('orders').doc(clientId).get().then(doc => {
    return doc.data().hasPaid
  })
}

async function GetOrder(clientId) {
  return await firebase.firestore().collection('orders').doc(clientId).get().then(function (doc) {
    return doc.data()
  })
}

function Success(props) {
  const clientId = props.match.params.id
  const [clientHasPaid, setClientHasPaid] = useState(false)
  const [order, setOrder] = useState({})

  useEffect(() => {
    GetPaymentStatus(clientId).then(data => setClientHasPaid(data)).catch(error => console.log(error))
    GetOrder(clientId).then(data => setOrder({
      name: data.name,
      position: data.position,
      price: data.price,
      design: {
        textColor: data.design.textColor,
        backgroundColor: data.design.backgroundColor,
        dropdown: data.design.dropdown,
        logo: data.design.logo,
        logoColor: data.design.logoColor,
        logoWidth: data.design.logoWidth
      }
    })).catch(error => console.log(error))
  }, [clientId])

  return clientHasPaid && order.price === 100 ? (
    <div>
      <PaidImagePreview order={order}/>
      <br/><br/>
      <ExportButton label="Export" clientHasPaid={clientHasPaid}/>
    </div>
  ) : clientHasPaid && order.price === 500 ? (
    <div>
      <PaidTemplatePreview order={order}/>
      <br/><br/>
      <p><small>Share this link with colleagues: {window.location.href}</small></p>
      <br/>
      <ExportButton label="Export" clientHasPaid={clientHasPaid}/>
    </div>
  ) : (
    <div>
      <h1>Loading...</h1>
      <br/><br/>
      <small><p>If you have finished reading this sentence, try refreshing the page.</p></small>
      <br/>
      <small><p>Psst... I don&apos;t like waiting either. The cloud database seems to require another minute to process your payment. Refresh?</p></small>
    </div>
  )
}

export default Success
